// extracted by mini-css-extract-plugin
module.exports = {"statisticCard":"statisticCard_statisticCard__11SJA","name":"statisticCard_name__11Tlw","value":"statisticCard_value__1qMMi"};